import React from 'react'
import { useQuery } from 'urql'

import { GetInvoiceDocument } from '@/gql/graphql'

import { processData } from './dataTransform'
import { Invoice } from './Invoice'

interface Props {
  billId: string
  collectionId?: string
  referenceId?: string
}

export const BillInvoice = ({ billId, collectionId, referenceId }: Props) => {
  const [{ data, fetching, error }] = useQuery({
    query: GetInvoiceDocument,
    variables: { billId, collectionId, referenceId },
  })

  const invoiceParams =
    billId && data
      ? processData({ billId, collectionId, referenceId, data })
      : {}

  return <Invoice fetching={fetching} error={error} {...invoiceParams} />
}
